import { useLocation } from 'react-router';


export function Login() {

    const location = useLocation();
    const from = location.state?.from;
    const loginUrl = `/login/entra${from ? `?returnTo=${encodeURIComponent(from)}` : ''}`;

    return (
        <div className='content'>
            <div className='login-form'>
                <h1 id='appName'>BG Web Apps</h1>
                <p>
                    <a href={loginUrl}>Sign in using Microsoft account</a>
                </p>
            </div>
        </div>
    );
}
